import { useNavigate } from "react-router";
import { toast } from "sonner";

export function OverviewPage() {
  const navigate = useNavigate();

  return (
    <section>
      <div className="page-head">
        <div>
          <h1>Overzicht</h1>
          <p>Academisch jaar 2025–2026 · Bijgewerkt op 25 juni 2026</p>
        </div>
      </div>

      <section className="stats">
        <div className="stat">
          <div className="stat__label">Actieve dossiers</div>
          <div className="stat__value">43</div>
          <div className="stat__delta up">▲ 6 t.o.v. vorige maand</div>
        </div>
        <div className="stat">
          <div className="stat__label">Pre-screening issues</div>
          <div className="stat__value">28</div>
          <div className="stat__delta">van 43 ingediend (65%)</div>
        </div>
        <div className="stat">
          <div className="stat__label">Gem. doorlooptijd</div>
          <div className="stat__value">12 d</div>
          <div className="stat__delta down">▼ doel: 10 dagen</div>
        </div>
        <div className="stat">
          <div className="stat__label">Herindieningsrate</div>
          <div className="stat__value">18%</div>
          <div className="stat__delta up">▼ 6% vs. vorig kwartaal</div>
        </div>
      </section>

      <section className="ua-grid">
        <div className="ua-col">
          <div className="card">
            <div className="card__head">
              <h2>Dossiers per processtap</h2>
              <span className="topbar__spacer" />
              <span className="ua-muted-sm">43 actief</span>
            </div>
            <div className="card__body p-0">
              <table className="table">
                <thead>
                  <tr>
                    <th>Processtap</th>
                    <th>Actor</th>
                    <th className="ua-text-right">Dossiers</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span className="step-dot dot--muted" />
                      Draft intake
                    </td>
                    <td className="ua-muted-sm">Onderzoeker</td>
                    <td className="ua-text-right font-bold">5</td>
                  </tr>
                  <tr>
                    <td>
                      <span className="step-dot dot--warning" />
                      Pre-screening: issues gevonden
                    </td>
                    <td className="ua-muted-sm">Onderzoeker</td>
                    <td className="ua-text-right font-bold">6</td>
                  </tr>
                  <tr>
                    <td>
                      <span className="step-dot dot--blue" />
                      Pre-screening: wacht op actie
                    </td>
                    <td className="ua-muted-sm">Onderzoeker</td>
                    <td className="ua-text-right font-bold">8</td>
                  </tr>
                  <tr>
                    <td>
                      <span className="step-dot dot--blue" />
                      Secr. klaar-check
                    </td>
                    <td className="ua-muted-sm">Secretariaat</td>
                    <td className="ua-text-right font-bold">7</td>
                  </tr>
                  <tr>
                    <td>
                      <span className="step-dot dot--navy" />
                      Reviewer briefing gereed
                    </td>
                    <td className="ua-muted-sm">Reviewer</td>
                    <td className="ua-text-right font-bold">5</td>
                  </tr>
                  <tr>
                    <td>
                      <span className="step-dot dot--navy" />
                      Bureau review loopt
                    </td>
                    <td className="ua-muted-sm">Bureau / Chair</td>
                    <td className="ua-text-right font-bold">12</td>
                  </tr>
                  <tr>
                    <td>
                      <span className="step-dot dot--success" />
                      Advies ondertekend
                    </td>
                    <td className="ua-muted-sm">Chair / Secr.</td>
                    <td className="ua-text-right font-bold">—</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="card">
            <div className="card__head">
              <h2>Recente dossiers</h2>
              <a
                href="#"
                className="cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  toast("Out of Scope", {
                    description: "Alle dossiers is buiten scope voor deze demo.",
                  });
                }}
              >
                Alles bekijken
              </a>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th>Onderzoeker</th>
                  <th>Project</th>
                  <th>Ingediend</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Lien Maes</td>
                  <td className="ua-muted-sm">Kwalitatief onderzoek in de jeugdzorg</td>
                  <td>24 jun</td>
                  <td>
                    <span className="badge badge--info">Reviewer toewijzen</span>
                  </td>
                </tr>
                <tr>
                  <td>Karim El Idrissi</td>
                  <td className="ua-muted-sm">Survey over migratie en gezondheid</td>
                  <td>23 jun</td>
                  <td>
                    <span className="badge badge--info">Reviewer toewijzen</span>
                  </td>
                </tr>
                <tr>
                  <td>Sofie Peeters</td>
                  <td className="ua-muted-sm">Interviews over psychische kwetsbaarheid</td>
                  <td>22 jun</td>
                  <td>
                    <span className="badge badge--warning">Bureau review</span>
                  </td>
                </tr>
                <tr>
                  <td>Tom Vermeulen</td>
                  <td className="ua-muted-sm">Observatiestudie op de arbeidsmarkt</td>
                  <td>21 jun</td>
                  <td>
                    <span className="badge badge--warning">Bureau review</span>
                  </td>
                </tr>
                <tr>
                  <td>An Declercq</td>
                  <td className="ua-muted-sm">Focusgroep over onderwijs en diversiteit</td>
                  <td>19 jun</td>
                  <td>
                    <span className="badge badge--success">Afgerond</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="ua-col">
          <div className="card">
            <div className="card__head">
              <h2>Veelvoorkomende issues</h2>
            </div>
            <div className="card__body">
              <ul className="progress">
                <li>
                  <div className="progress__top">
                    <span>Ontbrekende informed consent</span>
                    <span>14</span>
                  </div>
                  <div className="progress__track">
                    <div className="progress__fill w-[82%]" />
                  </div>
                </li>
                <li>
                  <div className="progress__top">
                    <span>GDPR / dataverwerkingsplan</span>
                    <span>11</span>
                  </div>
                  <div className="progress__track">
                    <div className="progress__fill w-[65%]" />
                  </div>
                </li>
                <li>
                  <div className="progress__top">
                    <span>Onvolledig risicoassessment</span>
                    <span>9</span>
                  </div>
                  <div className="progress__track">
                    <div className="progress__fill w-[53%]" />
                  </div>
                </li>
                <li>
                  <div className="progress__top">
                    <span>Fout template / versie</span>
                    <span>7</span>
                  </div>
                  <div className="progress__track">
                    <div className="progress__fill w-[41%]" />
                  </div>
                </li>
                <li>
                  <div className="progress__top">
                    <span>Kwetsbare doelgroep niet verantwoord</span>
                    <span>5</span>
                  </div>
                  <div className="progress__track">
                    <div className="progress__fill w-[29%]" />
                  </div>
                </li>
              </ul>
              <p className="ua-muted-xs ua-mt-sm">
                Gebaseerd op 43 actieve dossiers · AI-bevindingen, niet gevalideerd door
                secretariaat
              </p>
            </div>
          </div>
          <div className="panel-navy">
            <h2 className="mb-2 text-base">Volgende Bureau-vergadering</h2>
            <p className="m-0 mb-1 text-sm font-bold text-white">Woensdag 2 juli 2026</p>
            <p className="m-0 mb-4">
              12 dossiers op de agenda. Reviewer briefings beschikbaar voor 10 van 12.
            </p>
            <button
              className="btn btn--light text-sm"
              onClick={() => navigate("/dashboard/bureau?tab=agenda")}
            >
              Bekijk agenda
            </button>
          </div>
        </div>
      </section>
    </section>
  );
}
